"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.string.bold.js");
require("core-js/modules/es6.array.map.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _is_same_month = _interopRequireDefault(require("date-fns/is_same_month"));
var _gridStyled = require("grid-styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDeviceDetect = require("react-device-detect");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _filmStrip = _interopRequireDefault(require("@gravity/film-strip"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _excluded = ["themeQueries"];
var _jsxFileName = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/MonthSelector.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_obytr1jee() {
  var path = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/MonthSelector.js";
  var hash = "a0e923e6b859d8fb9da6655357edcc7870909d8c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/MonthSelector.js",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 35
        },
        end: {
          line: 23,
          column: 86
        }
      },
      "2": {
        start: {
          line: 53,
          column: 22
        },
        end: {
          line: 61,
          column: 1
        }
      },
      "3": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 83
        }
      },
      "4": {
        start: {
          line: 63,
          column: 26
        },
        end: {
          line: 74,
          column: 1
        }
      },
      "5": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "6": {
        start: {
          line: 77,
          column: 13
        },
        end: {
          line: 77,
          column: 53
        }
      },
      "7": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "8": {
        start: {
          line: 87,
          column: 22
        },
        end: {
          line: 125,
          column: 2
        }
      },
      "9": {
        start: {
          line: 127,
          column: 21
        },
        end: {
          line: 161,
          column: 1
        }
      },
      "10": {
        start: {
          line: 153,
          column: 52
        },
        end: {
          line: 156,
          column: 9
        }
      },
      "11": {
        start: {
          line: 163,
          column: 25
        },
        end: {
          line: 165,
          column: 1
        }
      },
      "12": {
        start: {
          line: 167,
          column: 26
        },
        end: {
          line: 169,
          column: 1
        }
      },
      "13": {
        start: {
          line: 168,
          column: 13
        },
        end: {
          line: 168,
          column: 86
        }
      },
      "14": {
        start: {
          line: 171,
          column: 22
        },
        end: {
          line: 252,
          column: 1
        }
      },
      "15": {
        start: {
          line: 173,
          column: 23
        },
        end: {
          line: 191,
          column: 3
        }
      },
      "16": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "17": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 15
        }
      },
      "18": {
        start: {
          line: 177,
          column: 23
        },
        end: {
          line: 177,
          column: 50
        }
      },
      "19": {
        start: {
          line: 178,
          column: 24
        },
        end: {
          line: 178,
          column: 48
        }
      },
      "20": {
        start: {
          line: 179,
          column: 21
        },
        end: {
          line: 179,
          column: 22
        }
      },
      "21": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 189,
          column: 10
        }
      },
      "22": {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 185,
          column: 7
        }
      },
      "23": {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 182,
          column: 95
        }
      },
      "24": {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 184,
          column: 21
        }
      },
      "25": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 36
        }
      },
      "26": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 18
        }
      },
      "27": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 190,
          column: 49
        }
      },
      "28": {
        start: {
          line: 192,
          column: 36
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "29": {
        start: {
          line: 193,
          column: 4
        },
        end: {
          line: 204,
          column: 5
        }
      },
      "30": {
        start: {
          line: 194,
          column: 28
        },
        end: {
          line: 194,
          column: 69
        }
      },
      "31": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 197,
          column: 7
        }
      },
      "32": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 15
        }
      },
      "33": {
        start: {
          line: 199,
          column: 30
        },
        end: {
          line: 199,
          column: 80
        }
      },
      "34": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 202,
          column: 7
        }
      },
      "35": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 15
        }
      },
      "36": {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 203,
          column: 38
        }
      },
      "37": {
        start: {
          line: 206,
          column: 35
        },
        end: {
          line: 206,
          column: 59
        }
      },
      "38": {
        start: {
          line: 207,
          column: 2
        },
        end: {
          line: 251,
          column: 4
        }
      },
      "39": {
        start: {
          line: 225,
          column: 12
        },
        end: {
          line: 246,
          column: 14
        }
      },
      "40": {
        start: {
          line: 226,
          column: 36
        },
        end: {
          line: 226,
          column: 94
        }
      },
      "41": {
        start: {
          line: 227,
          column: 14
        },
        end: {
          line: 245,
          column: 16
        }
      },
      "42": {
        start: {
          line: 235,
          column: 35
        },
        end: {
          line: 235,
          column: 93
        }
      },
      "43": {
        start: {
          line: 254,
          column: 0
        },
        end: {
          line: 278,
          column: 2
        }
      },
      "44": {
        start: {
          line: 280,
          column: 0
        },
        end: {
          line: 286,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 25
          },
          end: {
            line: 23,
            column: 26
          }
        },
        loc: {
          start: {
            line: 23,
            column: 35
          },
          end: {
            line: 23,
            column: 86
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 55,
            column: 12
          }
        },
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 83
          }
        },
        line: 56
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        loc: {
          start: {
            line: 77,
            column: 13
          },
          end: {
            line: 77,
            column: 53
          }
        },
        line: 77
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 79
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 153,
            column: 10
          },
          end: {
            line: 153,
            column: 11
          }
        },
        loc: {
          start: {
            line: 153,
            column: 52
          },
          end: {
            line: 156,
            column: 9
          }
        },
        line: 153
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 168,
            column: 5
          }
        },
        loc: {
          start: {
            line: 168,
            column: 13
          },
          end: {
            line: 168,
            column: 86
          }
        },
        line: 168
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 171,
            column: 22
          },
          end: {
            line: 171,
            column: 23
          }
        },
        loc: {
          start: {
            line: 171,
            column: 54
          },
          end: {
            line: 252,
            column: 1
          }
        },
        line: 171
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 173,
            column: 23
          },
          end: {
            line: 173,
            column: 24
          }
        },
        loc: {
          start: {
            line: 173,
            column: 50
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 173
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 180,
            column: 33
          },
          end: {
            line: 180,
            column: 34
          }
        },
        loc: {
          start: {
            line: 180,
            column: 55
          },
          end: {
            line: 189,
            column: 5
          }
        },
        line: 180
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 192,
            column: 36
          },
          end: {
            line: 192,
            column: 37
          }
        },
        loc: {
          start: {
            line: 192,
            column: 55
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 192
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 224,
            column: 44
          },
          end: {
            line: 224,
            column: 45
          }
        },
        loc: {
          start: {
            line: 225,
            column: 12
          },
          end: {
            line: 246,
            column: 14
          }
        },
        line: 225
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 225,
            column: 23
          },
          end: {
            line: 225,
            column: 24
          }
        },
        loc: {
          start: {
            line: 225,
            column: 32
          },
          end: {
            line: 246,
            column: 13
          }
        },
        line: 225
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 235,
            column: 29
          },
          end: {
            line: 235,
            column: 30
          }
        },
        loc: {
          start: {
            line: 235,
            column: 35
          },
          end: {
            line: 235,
            column: 93
          }
        },
        line: 235
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 35
          },
          end: {
            line: 23,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 54
          },
          end: {
            line: 23,
            column: 68
          }
        }, {
          start: {
            line: 23,
            column: 71
          },
          end: {
            line: 23,
            column: 86
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 13
          },
          end: {
            line: 56,
            column: 24
          }
        }, {
          start: {
            line: 56,
            column: 28
          },
          end: {
            line: 56,
            column: 48
          }
        }, {
          start: {
            line: 56,
            column: 52
          },
          end: {
            line: 56,
            column: 83
          }
        }],
        line: 56
      },
      "2": {
        loc: {
          start: {
            line: 77,
            column: 13
          },
          end: {
            line: 77,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 13
          },
          end: {
            line: 77,
            column: 30
          }
        }, {
          start: {
            line: 77,
            column: 34
          },
          end: {
            line: 77,
            column: 53
          }
        }],
        line: 77
      },
      "3": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 20
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 84,
            column: 3
          }
        }],
        line: 79
      },
      "4": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 119,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 17
          }
        }, {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 119,
            column: 9
          }
        }],
        line: 102
      },
      "5": {
        loc: {
          start: {
            line: 153,
            column: 20
          },
          end: {
            line: 153,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 153,
            column: 43
          },
          end: {
            line: 153,
            column: 45
          }
        }],
        line: 153
      },
      "6": {
        loc: {
          start: {
            line: 168,
            column: 13
          },
          end: {
            line: 168,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 13
          },
          end: {
            line: 168,
            column: 29
          }
        }, {
          start: {
            line: 168,
            column: 33
          },
          end: {
            line: 168,
            column: 86
          }
        }],
        line: 168
      },
      "7": {
        loc: {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 174
      },
      "8": {
        loc: {
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 15
          }
        }, {
          start: {
            line: 174,
            column: 19
          },
          end: {
            line: 174,
            column: 33
          }
        }],
        line: 174
      },
      "9": {
        loc: {
          start: {
            line: 181,
            column: 6
          },
          end: {
            line: 185,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 6
          },
          end: {
            line: 185,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "10": {
        loc: {
          start: {
            line: 182,
            column: 22
          },
          end: {
            line: 182,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 182,
            column: 61
          },
          end: {
            line: 182,
            column: 90
          }
        }, {
          start: {
            line: 182,
            column: 93
          },
          end: {
            line: 182,
            column: 94
          }
        }],
        line: 182
      },
      "11": {
        loc: {
          start: {
            line: 190,
            column: 11
          },
          end: {
            line: 190,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 30
          },
          end: {
            line: 190,
            column: 44
          }
        }, {
          start: {
            line: 190,
            column: 47
          },
          end: {
            line: 190,
            column: 48
          }
        }],
        line: 190
      },
      "12": {
        loc: {
          start: {
            line: 192,
            column: 37
          },
          end: {
            line: 192,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 192,
            column: 48
          },
          end: {
            line: 192,
            column: 50
          }
        }],
        line: 192
      },
      "13": {
        loc: {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 193
      },
      "14": {
        loc: {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 197,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 197,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 195
      },
      "15": {
        loc: {
          start: {
            line: 199,
            column: 30
          },
          end: {
            line: 199,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 30
          },
          end: {
            line: 199,
            column: 74
          }
        }, {
          start: {
            line: 199,
            column: 78
          },
          end: {
            line: 199,
            column: 80
          }
        }],
        line: 199
      },
      "16": {
        loc: {
          start: {
            line: 200,
            column: 6
          },
          end: {
            line: 202,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 200,
            column: 6
          },
          end: {
            line: 202,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 200
      },
      "17": {
        loc: {
          start: {
            line: 200,
            column: 10
          },
          end: {
            line: 200,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 200,
            column: 10
          },
          end: {
            line: 200,
            column: 16
          }
        }, {
          start: {
            line: 200,
            column: 20
          },
          end: {
            line: 200,
            column: 25
          }
        }],
        line: 200
      },
      "18": {
        loc: {
          start: {
            line: 209,
            column: 7
          },
          end: {
            line: 218,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 7
          },
          end: {
            line: 209,
            column: 31
          }
        }, {
          start: {
            line: 210,
            column: 8
          },
          end: {
            line: 217,
            column: 24
          }
        }],
        line: 209
      },
      "19": {
        loc: {
          start: {
            line: 235,
            column: 35
          },
          end: {
            line: 235,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 235,
            column: 35
          },
          end: {
            line: 235,
            column: 58
          }
        }, {
          start: {
            line: 235,
            column: 62
          },
          end: {
            line: 235,
            column: 93
          }
        }],
        line: 235
      },
      "20": {
        loc: {
          start: {
            line: 238,
            column: 23
          },
          end: {
            line: 238,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 238,
            column: 23
          },
          end: {
            line: 238,
            column: 46
          }
        }, {
          start: {
            line: 238,
            column: 50
          },
          end: {
            line: 238,
            column: 109
          }
        }],
        line: 238
      },
      "21": {
        loc: {
          start: {
            line: 239,
            column: 23
          },
          end: {
            line: 239,
            column: 124
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 23
          },
          end: {
            line: 239,
            column: 45
          }
        }, {
          start: {
            line: 239,
            column: 49
          },
          end: {
            line: 239,
            column: 124
          }
        }],
        line: 239
      },
      "22": {
        loc: {
          start: {
            line: 241,
            column: 21
          },
          end: {
            line: 241,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 241,
            column: 21
          },
          end: {
            line: 241,
            column: 44
          }
        }, {
          start: {
            line: 241,
            column: 48
          },
          end: {
            line: 241,
            column: 72
          }
        }, {
          start: {
            line: 241,
            column: 76
          },
          end: {
            line: 241,
            column: 82
          }
        }],
        line: 241
      },
      "23": {
        loc: {
          start: {
            line: 242,
            column: 21
          },
          end: {
            line: 242,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 242,
            column: 21
          },
          end: {
            line: 242,
            column: 44
          }
        }, {
          start: {
            line: 242,
            column: 48
          },
          end: {
            line: 242,
            column: 52
          }
        }],
        line: 242
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a0e923e6b859d8fb9da6655357edcc7870909d8c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_obytr1jee = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_obytr1jee();
var Wrapper = (cov_obytr1jee().s[0]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "g-calendar-monthSelector"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: ", ";\n      padding: 0 0 ", " 0;\n      flex-direction: row;\n      flex-wrap: wrap;\n    "])), function (props) {
  cov_obytr1jee().f[0]++;
  cov_obytr1jee().s[1]++;
  return props.mobileView ? (cov_obytr1jee().b[0][0]++, 'space-around') : (cov_obytr1jee().b[0][1]++, 'space-between');
}, _stylingConstants.default.spacing.small)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      padding-bottom: ", "px;\n\n      .g-FilmStrip-slider {\n        transition: unset;\n      }\n\n      .g-FilmStrip-Chevron {\n        > .g-Icon {\n          top: 50%;\n          transform: translateY(-50%);\n          box-shadow: none;\n          border: none;\n          background-color: var(--secondaryColor);\n          color: var(--secondaryTextColor);\n        }\n      }\n    "])), _themeMapper.evolutionTheme.spacings.lg))));
var SelectedMonth = (cov_obytr1jee().s[2]++, _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: ", ";\n  color: ", ";\n  text-transform: capitalize;\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n"])), _stylingConstants.default.font.sizeXl, function (props) {
  cov_obytr1jee().f[1]++;
  cov_obytr1jee().s[3]++;
  return (cov_obytr1jee().b[1][0]++, props) && (cov_obytr1jee().b[1][1]++, props.theme) && (cov_obytr1jee().b[1][2]++, props.theme.calendar) && (cov_obytr1jee().b[1][3]++, props.theme.calendar.titleColor);
}));
var SelectedMonthText = (cov_obytr1jee().s[4]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-calendar-monthSelector-SelectedMonthText"
}), (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    "]))))));
var SelectorWrapper = (cov_obytr1jee().s[5]++, _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  ", ";\n"])), function (props) {
  cov_obytr1jee().f[2]++;
  cov_obytr1jee().s[6]++;
  return (cov_obytr1jee().b[2][0]++, !props.mobileView) && (cov_obytr1jee().b[2][1]++, 'max-width: 442px;');
}, function (props) {
  cov_obytr1jee().f[3]++;
  cov_obytr1jee().s[7]++;
  return (cov_obytr1jee().b[3][0]++, props.mobileView) && (cov_obytr1jee().b[3][1]++, "\n    display:flex;\n    justify-content:space-around;\n    width: 100%\n  ");
}));
var SelectorStrip = (cov_obytr1jee().s[8]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_filmStrip.default), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    max-width: 100%;\n    .g-FilmStrip-sliderContainer {\n      .g-Button {\n        min-width: 110px;\n      }\n    }\n\n    ", ";\n  "])), _stylingConstants.default.mediaQueries.desktop(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n\n      ", "\n      "])), (cov_obytr1jee().b[4][0]++, _reactDeviceDetect.isDesktop) && (cov_obytr1jee().b[4][1]++, "\n          .g-FilmStrip-Chevron {\n            position: relative;\n            align-items: center;\n            display: -webkit-box;\n            display: -webkit-flex;\n            display: -ms-flexbox;\n            display: flex;\n            > .g-Icon {\n              top: inherit;\n            }\n\n            &.g-FilmStrip-leftChevron {\n              margin-right: 0.5rem;\n            }\n          }\n        ")))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    max-width: 100%;\n  "]))))));
var MonthWrapper = (cov_obytr1jee().s[9]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-calendar-MonthWrapper"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-block;\n      margin: 0 ", " 0 0;\n    "])), _stylingConstants.default.spacing.small)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      display: inline-block;\n      margin: 0;\n\n      > .g-Button {\n        width: 100%;\n        border: none !important;\n        background: transparent !important;\n        outline: none !important;\n        color: var(--textColor, #666);\n        display: flex;\n        align-items: center;\n        font-weight: ", ";\n        box-shadow: none !important;\n        cursor: unset;\n\n        ", ";\n      }\n    "])), _themeMapper.evolutionTheme.fontWeight.bold, function (_ref) {
  var _ref$theme = _ref.theme,
    _ref$theme2 = _ref$theme === void 0 ? (cov_obytr1jee().b[5][0]++, {}) : _ref$theme,
    boxTitleTextSize = _ref$theme2.boxTitleTextSize;
  cov_obytr1jee().f[4]++;
  cov_obytr1jee().s[10]++;
  return (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n          font-size: var(--boxTitleTextSize, 24px);\n          line-height: calc(var(boxTitleTextSize, 24px) * 1.5);\n        "])));
})), {
  useForwardRef: true
}));
var CapitalizedMonth = (cov_obytr1jee().s[11]++, _styledComponents.default.span(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  text-transform: capitalize !important;\n"]))));
var MonthTitleWrapper = (cov_obytr1jee().s[12]++, _styledComponents.default.span(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n"])), function (props) {
  cov_obytr1jee().f[5]++;
  cov_obytr1jee().s[13]++;
  return (cov_obytr1jee().b[6][0]++, props.mobileView) && (cov_obytr1jee().b[6][1]++, "padding-bottom: ".concat(_stylingConstants.default.spacing.xsmall, ";"));
}));
cov_obytr1jee().s[14]++;
var MonthSelector = function MonthSelector(_ref2) {
  var themeQueries = _ref2.themeQueries,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  cov_obytr1jee().f[6]++;
  cov_obytr1jee().s[15]++;
  // Count shifted number to display selected month in the middle the strip
  var countShifted = function countShifted(months, selectedMonth) {
    cov_obytr1jee().f[7]++;
    cov_obytr1jee().s[16]++;
    if ((cov_obytr1jee().b[8][0]++, !months) || (cov_obytr1jee().b[8][1]++, !selectedMonth)) {
      cov_obytr1jee().b[7][0]++;
      cov_obytr1jee().s[17]++;
      return 0;
    } else {
      cov_obytr1jee().b[7][1]++;
    }
    var selectYear = (cov_obytr1jee().s[18]++, selectedMonth.getFullYear());
    var selectMonth = (cov_obytr1jee().s[19]++, selectedMonth.getMonth());
    var shiftCount = (cov_obytr1jee().s[20]++, 0);
    cov_obytr1jee().s[21]++;
    (0, _entries.default)(months).every(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        year = _ref4[0],
        monthArr = _ref4[1];
      cov_obytr1jee().f[8]++;
      cov_obytr1jee().s[22]++;
      if (String(selectYear) === String(year)) {
        cov_obytr1jee().b[9][0]++;
        cov_obytr1jee().s[23]++;
        shiftCount += monthArr.indexOf(selectMonth) !== -1 ? (cov_obytr1jee().b[10][0]++, monthArr.indexOf(selectMonth)) : (cov_obytr1jee().b[10][1]++, 0);
        // break to not shift to another year
        cov_obytr1jee().s[24]++;
        return false;
      } else {
        cov_obytr1jee().b[9][1]++;
      }
      // shift over all month of this year
      cov_obytr1jee().s[25]++;
      shiftCount += monthArr.length;
      cov_obytr1jee().s[26]++;
      return true;
    }, 0);
    cov_obytr1jee().s[27]++;
    return shiftCount !== 0 ? (cov_obytr1jee().b[11][0]++, shiftCount - 1) : (cov_obytr1jee().b[11][1]++, 0);
  };
  cov_obytr1jee().s[28]++;
  var handleVisibleMonthsChange = function handleVisibleMonthsChange() {
    var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_obytr1jee().b[12][0]++, []);
    cov_obytr1jee().f[9]++;
    cov_obytr1jee().s[29]++;
    if (themeQueries.EVOLUTION) {
      var _ref6, _ReactDOM$findDOMNode;
      cov_obytr1jee().b[13][0]++;
      var middleElement = (cov_obytr1jee().s[30]++, elements[Math.floor(elements.length / 2)]);
      cov_obytr1jee().s[31]++;
      if (!middleElement) {
        cov_obytr1jee().b[14][0]++;
        cov_obytr1jee().s[32]++;
        return;
      } else {
        cov_obytr1jee().b[14][1]++;
      }
      // eslint-disable-next-line react/no-find-dom-node
      var _ref5 = (cov_obytr1jee().s[33]++, (_ref6 = (cov_obytr1jee().b[15][0]++, (_ReactDOM$findDOMNode = _reactDom.default.findDOMNode(middleElement)) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.dataset)) !== null && _ref6 !== void 0 ? _ref6 : (cov_obytr1jee().b[15][1]++, {})),
        month = _ref5.month,
        year = _ref5.year;
      cov_obytr1jee().s[34]++;
      if ((cov_obytr1jee().b[17][0]++, !month) || (cov_obytr1jee().b[17][1]++, !year)) {
        cov_obytr1jee().b[16][0]++;
        cov_obytr1jee().s[35]++;
        return;
      } else {
        cov_obytr1jee().b[16][1]++;
      }
      cov_obytr1jee().s[36]++;
      props.monthHandler(year, month);
    } else {
      cov_obytr1jee().b[13][1]++;
    }
  };
  var displaySelectedMonthText = (cov_obytr1jee().s[37]++, themeQueries.EQUILIBRIUM);
  cov_obytr1jee().s[38]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    mobileView: props.mobileView,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 208,
      columnNumber: 5
    }
  }, (cov_obytr1jee().b[18][0]++, displaySelectedMonthText) && (cov_obytr1jee().b[18][1]++, /*#__PURE__*/_react.default.createElement(SelectedMonth, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(SelectedMonthText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(MonthTitleWrapper, {
    mobileView: props.mobileView,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    value: props.selectedMonth,
    month: "long",
    year: "numeric",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 15
    }
  }))), /*#__PURE__*/_react.default.createElement(SelectedMonthText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 216,
      columnNumber: 11
    }
  }, props.monthDetails))), /*#__PURE__*/_react.default.createElement(SelectorWrapper, {
    mobileView: props.mobileView,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(SelectorStrip, {
    shifted: countShifted(props.months, new Date(props.selectedMonth)),
    onChange: handleVisibleMonthsChange,
    desktopSlider: !themeQueries.EQUILIBRIUM,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 9
    }
  }, (0, _entries.default)(props.months).map(function (_ref7) {
    var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
      year = _ref8[0],
      months = _ref8[1];
    cov_obytr1jee().f[10]++;
    cov_obytr1jee().s[39]++;
    return months.map(function (month) {
      cov_obytr1jee().f[11]++;
      var monthSelected = (cov_obytr1jee().s[40]++, (0, _is_same_month.default)(props.selectedMonth, new Date(year, month, 1)));
      cov_obytr1jee().s[41]++;
      return /*#__PURE__*/_react.default.createElement(MonthWrapper, {
        id: "g-calendar-monthSelector-".concat(year, "-").concat(month),
        key: "g-calendar-monthSelector-".concat(year, "-").concat(month),
        "data-year": year,
        "data-month": month,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 228,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        outline: !monthSelected,
        onClick: function onClick() {
          cov_obytr1jee().f[12]++;
          cov_obytr1jee().s[42]++;
          return (cov_obytr1jee().b[19][0]++, !themeQueries.EVOLUTION) && (cov_obytr1jee().b[19][1]++, props.monthHandler(year, month));
        },
        lines: 2,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 233,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(CapitalizedMonth, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 237,
          columnNumber: 21
        }
      }, (cov_obytr1jee().b[20][0]++, !themeQueries.EVOLUTION) && (cov_obytr1jee().b[20][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: new Date(year, month),
        month: "long",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 238,
          columnNumber: 51
        }
      })), (cov_obytr1jee().b[21][0]++, themeQueries.EVOLUTION) && (cov_obytr1jee().b[21][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: new Date(year, month),
        month: "long",
        year: "numeric",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 239,
          columnNumber: 50
        }
      }))), (cov_obytr1jee().b[22][0]++, !themeQueries.EVOLUTION) && (cov_obytr1jee().b[22][1]++, displaySelectedMonthText) && (cov_obytr1jee().b[22][2]++, /*#__PURE__*/_react.default.createElement("br", {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 241,
          columnNumber: 77
        }
      })), (cov_obytr1jee().b[23][0]++, !themeQueries.EVOLUTION) && (cov_obytr1jee().b[23][1]++, year)));
    });
  }))));
};
cov_obytr1jee().s[43]++;
MonthSelector.propTypes = {
  /** Pass the selected date to highlight the current button */
  selectedMonth: _propTypes.default.instanceOf(Date).isRequired,
  /** months are the list of months in the form of a map year -> array of month
   * {
   *  2018 : [1,3,6,7,8,9,12]
   * }
   */
  months: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.number)),
  /**
   * Action to apply when the mont is selected
   */
  monthHandler: _propTypes.default.func.isRequired,
  /**
   * Action to apply when the mont is selected
   */
  monthDetails: _propTypes.default.node,
  /**
   * Action to apply when the mont is selected
   */
  mobileView: _propTypes.default.bool.isRequired,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_obytr1jee().s[44]++;
MonthSelector.defaultProps = {
  months: [],
  monthDetails: '',
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(MonthSelector));